<template>
  <div
    :class="[classes.contentWrapper, classes[layoutClass], 'content-wrapper']"
  >
    <transition mode="out-in" name="fade">
      <span
        v-show="displayOverlay"
        :class="[classes.overlay, 'overlay']"
        @click="displayOverlay = !displayOverlay"
      />
    </transition>
    <TemplateSizeSelector />
  </div>
</template>

<script lang="ts">
import { createUseStyles } from "@fresh8/ad-data-composition/src/theme";
import { defineComponent, computed, ref } from "vue";
import TemplateSizeSelector from "./TemplateSizeSelector.vue";

import useBackgroundImage from "../hooks/useBackgroundImage";

import {
  MOBILE_LEADERBOARD,
  SMALL_RESPONSIVE,
  LEADERBOARD,
  injectTemplateSize
} from "@fresh8/ad-data-composition/src/useTemplateSize";
import { provideDisplayOverlay } from "../lib/provideInjectors";

const { useStyles } = createUseStyles<
  | "contentWrapper"
  | "overlay"
  | "small-responsive"
  | "leaderboard"
  | "mobile-leaderboard",
  {
    backgroundImage: string;
  }
>({
  contentWrapper: {
    backgroundImage: props =>
      props.backgroundImage && `url("${props.backgroundImage}")`,
    padding: "5px 8px",
    boxSizing: "border-box",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    position: "relative",
    height: "100%",
    width: "100%"
  },
  overlay: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 900,
    background: "rgba(0,0,0,0.6)"
  },
  [SMALL_RESPONSIVE.name]: {
    padding: "2px 5px 1px"
  },
  [MOBILE_LEADERBOARD.name]: {
    padding: 0,
    borderRadius: 0
  },
  [SMALL_RESPONSIVE.name]: {
    padding: "2px 5px 1px"
  },
  [LEADERBOARD.name]: {
    padding: 0
  }
});

export default defineComponent({
  name: "AdContent",
  props: {
    sizeId: {
      type: String,
      required: true
    }
  },
  components: {
    TemplateSizeSelector
  },
  setup(props) {
    const displayOverlay = ref(false);
    provideDisplayOverlay(displayOverlay);
    const templateSize = injectTemplateSize();
    const reactiveSizeId = computed(() => props.sizeId);

    const backgroundImageData = useBackgroundImage(
      reactiveSizeId,
      "background"
    );
    const { classesRef } = useStyles(
      computed(() => ({
        backgroundImage: backgroundImageData.value.backgroundImage
      }))
    );

    return {
      classes: classesRef,
      displayOverlay,
      layoutClass: computed(() => templateSize.size.value.name)
    };
  }
});
</script>
